<template>
	<div class="category-header-row" :class="{ 'is-virtual': isVirtual }">
		<div class="category-header" :style="'--category-color: '+category.color+';--category-text-color: '+categoryTextColor(category.color)">{{ categoryDisplayName(category.name) }}</div>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {isTextColorDark} from "@/shared/helpers/ui";

export default {
	setup() {
		let languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	name: "CounterCategoryHeader",
	props: {
		isVirtual: {
			type: Boolean,
			default: false,
		},
		category: {
			type: Object,
			required: true,
			validator: (cat) => {
				return cat.hasOwnProperty("name") && cat.hasOwnProperty("color");
			},
		},
	},
	methods: {
		categoryTextColor(color) {
			if(isTextColorDark(color)) {
				return "#000000";
			} else {
				return "#ffffff";
			}
		},
		categoryDisplayName(name) {
			return (name !== "" ? name : this.getString('no_name_cat'));
		},
	},
}
</script>

<style scoped lang="scss">
.category-header-row {
	display: flex;
	align-items: center;
	height: 48px;

	.category-header {
		width: 82%;
		max-width: 500px;
		padding: 2px 33px 2px 10px;
		background-color: var(--category-color);
		color: var(--category-text-color);
		position: relative;
		display: flex;
		align-items: center;
		border-radius: 7px;
		font-size: 16px;
		white-space: nowrap;
		text-overflow: ellipsis;

		&:before {
			content: "";
			display: block;
			width: 40px;
			height: 100%;
			position: absolute;
			top: 0;
			right: -10px;
			background-color: var(--category-color);
			transform: skew(-15deg);
			border-radius: 7px;
		}
	}

	&.is-virtual {
		.category-header {
			width: calc(100% - 10px);
			max-width: calc(100% - 10px);
			color: var(--color-primary);
			background-color: var(--color-bg-primary-2);

			&:after {
				content: none;
			}
			&:before {
				background-color: var(--color-bg-primary-2);
			}
		}
	}
}
</style>
